import React from 'react'
import {
    Box,
    AspectRatio,

    /* Hooks */
    useMultiStyleConfig
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {getHideStyles} from '../../utils/utils'

/* Components */
import CategoryBannerBlock from '../../layouts/categoryBannerBlock'

const GridInteruptorBlock = ({ data, position, breakpoint }) => {
    const {
        GridInteruptorCTA,
        GridInteruptorBlockPreTitleStyle,
        GridInteruptorBlockTitleStyle,
        GridInteruptorBlockDescriptionStyle,
        GridInteruptorBlockDisclaimerStyle,
        GridInteruptorBlockTooltipStyle,
        GridInteruptorAlignment = 'left',
        HideOnDevices
    } = data

    const hideStyles = getHideStyles(HideOnDevices)

    if (!data || hideStyles.doNotLoadComponent) {
        return null
    }

    const getGridSize = () => {
        switch (breakpoint) {
            case 'mobile':
                return data.GridInteruptorSizeMobile || '1x1'
            case 'tablet':
                return data.GridInteruptorSizeLayout2 || '1x1'
            case 'desktop':
                return data.GridInteruptorSizeLayout3 || '1x1'
            case 'xl':
                return data.GridInteruptorSizeLayout4 || '1x1'
            default:
                return '1x1'
        }
    }

    const gridSize = getGridSize()

    const getGridSpanProps = () => {
        const maxGridColumns = breakpoint === 'mobile' ? 2 : 4
        const columnSpan = gridSize === '2x1' ? Math.min(2, maxGridColumns) : 1

        return {
            gridColumn: `span ${columnSpan}`
        }
    }

    const gridSpanProps = getGridSpanProps()

    const styles = useMultiStyleConfig('GridInteruptorBlock', { ...data, gridSize: gridSize })

    return (
        <Box
            {...styles?.container}
            {...gridSpanProps}
            data-testid={`grid-interruptor-${position}`}
            {...hideStyles}
        >
            <AspectRatio {...styles?.wrapper}>
                <Box {...styles?.ratioContainer}>
                    <CategoryBannerBlock
                        {...data}
                        CtaAlignment={'vertical'}
                        Alignment={GridInteruptorAlignment}
                        BannerAlignment={GridInteruptorAlignment}
                        BannerCTA={GridInteruptorCTA}
                        CategoryBannerBlockPreTitleStyle={GridInteruptorBlockPreTitleStyle}
                        CategoryBannerBlockTitleStyle={GridInteruptorBlockTitleStyle}
                        CategoryBannerBlockDescriptionStyle={GridInteruptorBlockDescriptionStyle}
                        CategoryBannerBlockDisclaimerStyle={GridInteruptorBlockDisclaimerStyle}
                        CategoryBannerBlockTooltipStyle={GridInteruptorBlockTooltipStyle}
                        overwriteContainerStyling={{
                            width: '100%',
                            height: '100%',
                            padding: 0
                        }}
                        overwriteWrapperStyling={{
                            height: '100%',
                            padding: {base: 3, lg: 6}
                        }}
                        overwriteTitleStyling={{
                            marginBottom: {base: 3, lg: 3}
                        }}
                        overwriteCtaWrapperStyling={{
                            marginTop: {base: 3, lg: 3}
                        }}
                    />
                </Box>
            </AspectRatio>
        </Box>
    )
}

GridInteruptorBlock.propTypes = {
    data: PropTypes.object.isRequired,
    position: PropTypes.number.isRequired,
    breakpoint: PropTypes.string.isRequired
}

export default GridInteruptorBlock
